<div *ngIf="model">
  <div class="row" class="p-l-0">
    <h4 class="t-a-center m-b-0 p-5-0 bg-c-E7EBEE">
      Записи пацієнта на прийом
    </h4>
  </div>
  <div class="row">
    <div class="col-md-6 col-lg-3">
      <label class="form-label">Прізвище</label>
      <kendo-textbox value="{{ model.lastName }}" [disabled]="true"></kendo-textbox>
    </div>
    <div class="col-md-6 col-lg-3">
      <label class="form-label">Ім'я</label>
      <kendo-textbox value="{{ model.firstName }}" [disabled]="true"></kendo-textbox>
    </div>
    <div class="col-md-6 col-lg-3">
      <label class="form-label">По батькові</label>
      <kendo-textbox value="{{ model.patronymic }}" [disabled]="true"></kendo-textbox>
    </div>
    <div class="col-md-6 col-lg-3">
      <label class="form-label">Телефон</label>
      <kendo-textbox value="+38 {{ model.phone1 }}" [disabled]="true"></kendo-textbox>
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <br />
      <kendo-grid [data]="model.appointments" 
        [size]="'small'" 
        kendoGridSelectBy="id" 
        [selectable]="selectableSettings" 
        [(selectedKeys)]="mySelection">
        <!-- <kendo-grid-column field="queue.date" title="Дата" [width]="100"></kendo-grid-column>
        <kendo-grid-column field="queue.combinedTime" title="Час" [width]="110"> </kendo-grid-column>
        <kendo-grid-column field="queue.medicalAppointment.serviceProvider" title="Лікар, спеціалізація"></kendo-grid-column>
        <kendo-grid-column field="comment" title="Коментар" [width]="100"></kendo-grid-column> -->
        <kendo-grid-column field="combinedData" title="Дата, час, лікар, спеціалізація"></kendo-grid-column>
        <kendo-grid-column field="date" title="" [width]="100">
          <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
            <button kendoButton *ngIf="dataItem.isDeletable" 
              themeColor="primary" 
              (click)="mySelection = [ dataItem.id ]; errMessage = ''; deletingQueueId = dataItem.id;"
            >
              Відмінити
            </button>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-messages noRecords="Немає записів для перегляду."></kendo-grid-messages>
      </kendo-grid>
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <br />
      <div class="alert-warning">
        Під час повітряної тривоги амбулаторний прийом пацієнтів не проводиться, послуги не надаються.<br />
        Медичний персонал і пацієнти мають перебувати в укритті.<br />
        Будь-які не екстренні медичні маніпуляції припиняються.<br />
        Просимо враховувати дані обставини! Ваш запис по незалежним від закладу обставинам може не відбутися.
      </div>
    </div>
  </div>

</div>



<kendo-dialog
  title="Відміна запису на прийом"
  *ngIf="deletingQueueId"
  (close)="deletingQueueId = ''; mySelection = []; "
  [width]="450"
>
  <div class="example">

    <legend *ngIf="errMessage" class="k-form-legend" style="color:red;">
      {{errMessage}}
      <br /><br />
    </legend>

    Вибраний запис на прийом буде видалено. Продовжити? <br /><br />

    <kendo-dialog-actions [layout]="'end'">
      <div class="k-form-buttons">
        <button kendoButton themeColor="primary" (click)="deleteAppointment()">Так</button>
        <button kendoButton (click)="deletingQueueId = ''; mySelection = []; ">Ні</button>
      </div>
    </kendo-dialog-actions>

  </div>
</kendo-dialog>
